import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { MVKPhase } from '../../types/mvk_state';
import { scrollToElement } from '../../utils/dom/scroll';
import { AvailableScrollDirection, getAvailableScrollDirection } from '../../utils/dom/scrollDirection';
import { getMapLink } from '../../utils/map/helpers';
import { trackFlatInFloorPlanClick, trackSectionClick, trackSimilarFlatClick, trackSimilarSuggestionsClick } from '../../utils/tracking';
import { NoOffers } from '../no_offers';
import { PickerInfo } from '../picker_info';
import { SideBlockHouseCard } from '../side_block_house_card';
import { SideBlockOfferCard } from '../side_block_offer_card';
import { TitleLink } from '../title_link';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SideBlockHousePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(SideBlockHousePicker, _React$Component);
  var _super = _createSuper(SideBlockHousePicker);
  function SideBlockHousePicker() {
    var _this;
    _classCallCheck(this, SideBlockHousePicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "list", null);
    _defineProperty(_assertThisInitialized(_this), "state", {
      availableScrollDirection: AvailableScrollDirection.Bottom
    });
    _defineProperty(_assertThisInitialized(_this), "onSectionCardSelect", function (section) {
      trackSectionClick(_this.props.isOfferCard);
      _this.props.setHouseId(section.house.id);
      _this.props.setSectionId(section.id);
    });
    _defineProperty(_assertThisInitialized(_this), "onSideBlockOfferCardSelect", function (offer) {
      trackFlatInFloorPlanClick(_this.props.isOfferCard);
      _this.props.setFlatId(offer.id);
    });
    _defineProperty(_assertThisInitialized(_this), "onSideBlockSimilarOfferCardSelect", function (offer) {
      trackSimilarFlatClick(offer.analyticsData && offer.analyticsData.customUrl || '');
      _this.props.setFlatId(offer.id);
    });
    _defineProperty(_assertThisInitialized(_this), "handleElementScroll", function (e) {
      var availableScrollDirection = getAvailableScrollDirection(e);
      if (_this.state.availableScrollDirection !== availableScrollDirection) {
        _this.setState({
          availableScrollDirection: availableScrollDirection
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getHeader", function () {
      var _this$props = _this.props,
        selectedSection = _this$props.selectedSection,
        currentPhase = _this$props.currentPhase,
        sectionPhaseFilters = _this$props.sectionPhaseFilters;
      var shouldRenderLink = [MVKPhase.SECTION, MVKPhase.FLAT].includes(currentPhase);
      if (shouldRenderLink) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [currentPhase === MVKPhase.SECTION ? _this.renderSectionTitleLink() : _this.renderFlatTitleLink(), /*#__PURE__*/_jsx(PickerInfo, {
            selectedSection: selectedSection,
            floor: sectionPhaseFilters.selectedFloor,
            isFlatView: currentPhase === MVKPhase.FLAT
          }, 2)]
        });
      } else {
        return _this.renderTitleText();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderSectionTitleLink", function () {
      return /*#__PURE__*/_jsx(TitleLink, {
        onClick: _this.onSectionTitleLinkClick,
        children: "\u041A \u0432\u044B\u0431\u043E\u0440\u0443 \u043A\u043E\u0440\u043F\u0443\u0441\u0430"
      }, 1);
    });
    _defineProperty(_assertThisInitialized(_this), "renderFlatTitleLink", function () {
      return /*#__PURE__*/_jsx(TitleLink, {
        onClick: _this.onFlatTitleLinkClick,
        children: "\u041A \u0432\u044B\u0431\u043E\u0440\u0443 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B"
      }, 1);
    });
    _defineProperty(_assertThisInitialized(_this), "renderTitleText", function () {
      var _this$props2 = _this.props,
        newbuildingName = _this$props2.newbuildingName,
        currentPhase = _this$props2.currentPhase;
      var availableScrollDirection = _this.state.availableScrollDirection;
      var isOfferView = currentPhase === MVKPhase.FLAT;
      var text = isOfferView ? 'Похожие квартиры на других этажах' : "\u041A\u043E\u0440\u043F\u0443\u0441\u0430 \u0432 \u0416\u041A \xAB".concat(newbuildingName, "\xBB");
      return /*#__PURE__*/_jsx("h4", _objectSpread(_objectSpread({}, mergeStyles([styles['title'], currentPhase === MVKPhase.FLAT && styles['title--small_margin'], [AvailableScrollDirection.Top, AvailableScrollDirection.Both].includes(availableScrollDirection) && styles['title--top-gradient']])), {}, {
        children: text
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "getSectionViewItems", function () {
      var _this$props3 = _this.props,
        _this$props3$parsedSe = _this$props3.parsedSections,
        parsedSections = _this$props3$parsedSe === void 0 ? [] : _this$props3$parsedSe,
        hoveredId = _this$props3.hoveredId;
      return parsedSections.map(function (section) {
        return /*#__PURE__*/_jsx(SideBlockHouseCard, {
          titlePrefix: "\u0421\u0435\u043A\u0446\u0438\u044F ",
          isHovered: section.id === hoveredId,
          section: section,
          onSelect: _this.onSectionCardSelect,
          onMouseEnter: _this.onSideBlockHouseCardMouseEnter,
          onMouseLeave: _this.onSideBlockHouseCardMouseLeave
        }, section.id);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getOfferViewItems", function () {
      var _this$props4 = _this.props,
        _this$props4$parsedOf = _this$props4.parsedOffers,
        parsedOffers = _this$props4$parsedOf === void 0 ? [] : _this$props4$parsedOf,
        hoveredId = _this$props4.hoveredId;
      return parsedOffers.map(function (offer, index) {
        return /*#__PURE__*/_jsx(SideBlockOfferCard, {
          isHovered: offer.id === hoveredId,
          offer: offer,
          onSelect: _this.onSideBlockOfferCardSelect,
          onHover: _this.props.setHoveredFlatId
        }, offer.flatNumber + offer.roomsTitle + index);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onSectionTitleLinkClick", function () {
      _this.props.clearSectionId();
    });
    _defineProperty(_assertThisInitialized(_this), "onFlatTitleLinkClick", function () {
      _this.props.clearFlatId();
    });
    _defineProperty(_assertThisInitialized(_this), "getSimilarOffersViewItems", function () {
      var _this$props$parsedSim = _this.props.parsedSimilarOffers,
        parsedSimilarOffers = _this$props$parsedSim === void 0 ? [] : _this$props$parsedSim;
      return parsedSimilarOffers.map(function (offer, index) {
        return /*#__PURE__*/_jsx(SideBlockOfferCard, {
          isSimilarPhase: true,
          offer: offer,
          onSelect: _this.onSideBlockSimilarOfferCardSelect
        }, offer.flatNumber + offer.roomsTitle + index);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onSideBlockHouseCardMouseEnter", function (section) {
      _this.props.setHoveredSectionId(section.id, section.house.id, true);
    });
    _defineProperty(_assertThisInitialized(_this), "onSideBlockHouseCardMouseLeave", function () {
      _this.props.setHoveredSectionId();
    });
    return _this;
  }
  _createClass(SideBlockHousePicker, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var isViewTypeChanged = this.props.currentPhase !== nextProps.currentPhase;
      var isHoveredIdChanged = nextProps.hoveredId !== undefined && this.props.hoveredId !== nextProps.hoveredId;
      if (!nextProps.shouldIgnoreScroll && isHoveredIdChanged || isViewTypeChanged) {
        scrollToElement(this.list, isViewTypeChanged ? document.querySelector("[id^=house-card-]") : document.querySelector("#house-card-".concat(nextProps.hoveredId)));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props5 = this.props,
        currentPhase = _this$props5.currentPhase,
        geoInfo = _this$props5.geoInfo,
        isOfferCard = _this$props5.isOfferCard;
      var availableScrollDirection = this.state.availableScrollDirection;
      var mapUrl = getMapLink(geoInfo);
      var items = null;
      switch (currentPhase) {
        case MVKPhase.PREVIEW:
          items = this.getSectionViewItems();
          break;
        case MVKPhase.SECTION:
          items = this.getOfferViewItems();
          break;
        case MVKPhase.FLAT:
          items = this.getSimilarOffersViewItems();
          break;
        default:
          break;
      }
      var body = currentPhase === MVKPhase.FLAT && Array.isArray(items) && !items.length ? /*#__PURE__*/_jsx(NoOffers, {}) : /*#__PURE__*/_jsx("ul", {
        ref: function ref(_ref) {
          return _this2.list = _ref;
        },
        className: styles['house_list'],
        children: items
      });
      return /*#__PURE__*/_jsxs("div", {
        onScroll: this.handleElementScroll,
        className: styles['container'],
        children: [this.getHeader(), body, /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles([styles['link_wrapper'], [AvailableScrollDirection.Bottom, AvailableScrollDirection.Both].includes(availableScrollDirection) && styles['link_wrapper--top_gradient']])), {}, {
          children: currentPhase === MVKPhase.PREVIEW && /*#__PURE__*/_jsx("a", {
            className: styles['link'],
            target: "_blank",
            href: mapUrl,
            onClick: function onClick() {
              return trackSimilarSuggestionsClick(isOfferCard);
            },
            children: "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u044F\u0434\u043E\u043C"
          })
        }))]
      });
    }
  }]);
  return SideBlockHousePicker;
}(React.Component);